import { MarketingMessage } from "@app/core/marketing/domain/marketing-message";
import { Observable } from "rxjs";

/*
 * Repository used to get marketing message.
 */
export abstract class MarketingMessageRepo {
  /*
   * Get marketing message.
   * @param token User token.
   * @returns Marketing message.
   */
  abstract getMarketingMessage(token: string): Observable<MarketingMessage>;
}
